import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WhatsappIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M18.7,6A9.5,9.5,0,0,0,12,3.36a9.29,9.29,0,0,0-9.42,9.13,8.92,8.92,0,0,0,1.26,4.56L2.54,21.78l5-1.27A9.64,9.64,0,0,0,12,21.62h0a9.36,9.36,0,0,0,9.5-9.13A9.06,9.06,0,0,0,18.7,6ZM12,20.09a8,8,0,0,1-4-1.06l-.28-.17-3,.76.79-2.8-.19-.29a7.35,7.35,0,0,1-1.2-4A7.73,7.73,0,0,1,12,4.9a7.85,7.85,0,0,1,5.53,2.23A7.46,7.46,0,0,1,20,12.49,7.8,7.8,0,0,1,12,20.09Zm4.29-5.69c-.23-.11-1.39-.66-1.61-.74s-.37-.11-.53.12a10.26,10.26,0,0,1-.74.89c-.14.16-.28.18-.51.06A6.37,6.37,0,0,1,9.74,12c-.25-.41.24-.38.69-1.25a.43.43,0,0,0,0-.4c-.06-.11-.53-1.24-.73-1.69s-.39-.38-.53-.39H8.7a.91.91,0,0,0-.63.28,2.56,2.56,0,0,0-.82,1.91,4.35,4.35,0,0,0,1,2.36,10.43,10.43,0,0,0,4,3.44,4.65,4.65,0,0,0,2.82.57,2.38,2.38,0,0,0,1.59-1.08,1.84,1.84,0,0,0,.14-1.09C16.72,14.57,16.56,14.51,16.33,14.4Z" />
    </SvgIcon>
  )
}
export default WhatsappIcon
